import React from "react";

import { HeaderVacantes } from "../../../components/Public/Consulta_Vacantes/HeaderVacantes";
import { ConsultadeVacantesComponent } from "../../../components/Public/Consulta_Vacantes/ConsultadeVacantes";
import { Row, Col, BackTop } from "antd";
import { ContenidoVacantes } from "../../../components/Public/Consulta_Vacantes/ContenidoVacantes";
import { ConsultaTotalVacantesComponent } from "../../../components/Public/Consulta_Vacantes/ConsultaTotalVacantes";
import "./ConsultaDeVacantesPage.css";

export const ConsultadeVacantesPage = () => {
    return (
        <>
            <div className="mainConsultaDeVacantesPage">
                <Row>
                    <Col span={24}>
                        <HeaderVacantes />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <ConsultaTotalVacantesComponent />
                    </Col>
                </Row>
                <Row className="layout-content-public" style={{marginBottom: "50px"}}>
                    <Col xs={{span:24}} xl={{span:9}}>
                    <ConsultadeVacantesComponent />
                    </Col>
                    <Col xs={{span:0}} xl={{span:14}}>
                    <ContenidoVacantes />
                    </Col>
                </Row>
                <BackTop className="back-top" />
            </div>
        </>
    );
};
